module.exports = __webpack_public_path__ + "static/ogimg-our-vision-324dc32e05d89432709f54b3e18f5b50.jpg";